<template>
  <path :id="`${id}`" :d="path"></path>
</template>
<script>
export default {
  name: "CircleSection",
  props: {
    id: String,
    rotation: Number,
    angle: Number,
    radius: Number,
    inner_radius: {
      required: false,
      type: Number,
      default: 0
    },
    close: {
      required: false,
      type: Boolean,
      default: true
    },
    x: {
      required: false,
      type: Number,
      default: 0
    },
    y: {
      required: false,
      type: Number,
      default: 0
    }
  },
  computed: {
    x1() {
      return this.x + Math.cos(this.rotation - this.angle / 2) * this.radius;
    },
    y1() {
      return this.y - Math.sin(this.rotation - this.angle / 2) * this.radius;
    },
    x2() {
      return this.x + Math.cos(this.rotation + this.angle / 2) * this.radius;
    },
    y2() {
      return this.y - Math.sin(this.rotation + this.angle / 2) * this.radius;
    },
    x1_inner() {
      return (
        this.x + Math.cos(this.rotation - this.angle / 2) * this.inner_radius
      );
    },
    y1_inner() {
      return (
        this.y - Math.sin(this.rotation - this.angle / 2) * this.inner_radius
      );
    },
    x2_inner() {
      return (
        this.x + Math.cos(this.rotation + this.angle / 2) * this.inner_radius
      );
    },
    y2_inner() {
      return (
        this.y - Math.sin(this.rotation + this.angle / 2) * this.inner_radius
      );
    },
    path() {
      let d = `M ${this.x2},${this.y2}
                A ${this.radius},${this.radius} 0 0,1 ${this.x1},${this.y1}`;

      if (this.inner_radius > 0) {
        d =
          d +
          ` L ${this.x1_inner},${this.y1_inner}
                  A ${this.inner_radius},${this.inner_radius} 0 0,0 ${this.x2_inner},${this.y2_inner} z`;
      } else if (this.close) {
        d = d + " L 0,0 z";
      }
      return d;
    }
  }
};
</script>
<style lang="scss" scoped>
// path {
//   transition: d 2s ease;
// }
</style>
